import React, { ReactNode } from 'react';
import { DefaultButton } from './Button.styles';

type ColorPreset = 'primary' | 'secondary' | 'light';
type ButtonType = 'button' | 'submit' | 'reset';

const defaultProps = {
  small: false,
  color: 'primary',
  ghost: false,
  disabled: false,
  className: '',
  testId: 'Button',
  type: 'button'
} as Partial<ButtonProps>;

type ButtonProps = {
  small?: boolean;
  color?: ColorPreset;
  ghost?: boolean;
  disabled?: boolean;
  className?: string;
  testId?: string;
  type?: ButtonType;
  onClick?: (e?: React.MouseEvent<HTMLButtonElement>) => void;
  children: ReactNode;
};

const Button: React.FC<ButtonProps> = ({
  small,
  color,
  ghost,
  disabled,
  className,
  testId,
  children,
  onClick,
  type,
  ...props
}: ButtonProps) => {
  return (
    <DefaultButton
      small={small}
      color={color}
      ghost={ghost}
      disabled={disabled}
      data-cv-test={testId}
      type={type}
      className={className}
      onClick={onClick}
      {...props}
    >
      {children}
    </DefaultButton>
  );
};

Button.defaultProps = defaultProps;

export default Button;
